(() => {
  /* Services */

  var adtService = angular.module('adtServices', ['ngResource']);

  adtService.factory('ReportItem', function ($resource) {
    return $resource('/reportitem/:action/:id', {}, {
      'exclude': {
        method: 'POST',
        params: {
          action: 'exclude'
        }
      }
    });
  });

  adtService.factory('Label', function ($resource) {
      var label = $resource('/label/:action/:id', {}, {
          'addAll': {
              method: 'POST',
              params: {
                  action: 'addall'
              },
              isArray: true
          },
          'removeAll': {
              method: 'POST',
              params: {
                  action: 'removeall'
              },
              isArray: true
          },
          'query': {
              method: 'GET',
              params: {
                  action: 'query'
              }
          }
      });
      return label;
  });

  adtService.factory('Targetgroup', function ($resource) {
      var target = $resource('/targetgroup/:action/:id', {}, {
          'catNames': {
              method: 'GET',
              params: {
                  action: 'catnames'
              }
          },
          'size': {
            method: 'POST',
            params: {
              action: 'size'
            }
          }
      });

      return target;
  });

  adtService.config(function($httpProvider) {
      $httpProvider.interceptors.push(function($q) {
          return {
              'request': function(config) {
                  if (window.ICS_CONFIG && config.url.indexOf(window.ICS_CONFIG.host) >= 0) {
                      config.headers['Authorization'] = `Bearer ${window.ICS_CONFIG.token}`;
                  }
                  return config;
              }
          };
      });
  });

  adtService.factory('IcsSettings', function ($resource){
      var intercept =  $resource(`https://${window.ICS_CONFIG.host}/settingsRequest/:action/:id`, {}, {
          'get':{
              method: 'GET',
              params: {
                  action: 'get'
              }
          },
          'update': {
              method: 'POST',
              params: {
                  action: 'update'
              }
          },
          'getSnippet': {
              method: 'GET',
              params: {
                  action: 'snippet'
              }
          }
      });
      return intercept;
  });

  adtService.factory("InterceptionReport", function ($resource){
      var interceptionReport =  $resource(`https://${window.ICS_CONFIG.host}/progress/:action/:id`, {}, {
          'list':{
              method: 'GET',
              params: {
                  action: 'list'
              }
          }
      });
      return interceptionReport;
  });

  adtService.factory("Interceptions", function ($resource){
      var intercept =  $resource(`https://${window.ICS_CONFIG.host}/interception/:action/:id`, {}, {
          'list':{
              method: 'GET',
              params: {
                  action: 'list'
              }
          },
          'get': {
              method: 'Get',
              params: {
                  action: 'get'
              }
          },
          'add': {
              method: 'POST',
              params: {
                  action: 'add'
              }
          },
          'update': {
              method: 'POST',
              params: {
                  action: 'update'
              }
          },
          'start': {
              method: 'POST',
              params:{
                  action: 'start'
              }
          },
          'delete': {
              method: 'DELETE',
              params:{
                  action: 'delete'
              }
          },
          'stop': {
              method: 'POST',
              params:{
                  action: 'stop'
              }
          }
      });
      return intercept;
  });
})();
